import {beforeInputHandler, focusHandler, blurHandler} from '../plugins/simpleMask'

const simpleMask = {
  mounted(el, binding) {
    if (binding.value) {
      let setter = el._assign;
      if (el._assign === undefined) {
        setter = function (val) {
          el.value = val;
          el.dispatchEvent(new Event('input'));
        }
      }
      el.addEventListener('beforeinput', (event) => {
        beforeInputHandler(event, binding.value, setter);
      });
      el.addEventListener('focus', (event) => {
        focusHandler(event, binding.value, setter);
      });
      el.addEventListener('blur', (event) => {
        blurHandler(event, binding.value, setter);
      });
    }
  },
};

export {simpleMask};

